import { render, staticRenderFns } from "./WaveTitle.vue?vue&type=template&id=632baf26&scoped=true&"
import script from "./WaveTitle.vue?vue&type=script&name=wave-title&lang=js&"
export * from "./WaveTitle.vue?vue&type=script&name=wave-title&lang=js&"
import style0 from "./WaveTitle.vue?vue&type=style&index=0&id=632baf26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632baf26",
  null
  
)

export default component.exports